angular
  .module 'filters'
  .filter 'month', (Months) ->
    (number) ->
      if number
        Months[number - 1][1]
